const SESSION_KEY = 'pixeloop.client_session_id'

let inMemorySessionId = ''

function generateId(): string {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

function safeGetStorage(): Storage | null {
  try {
    return globalThis.localStorage ?? null
  } catch {
    return null
  }
}

export function getClientSessionId(): string {
  if (inMemorySessionId) return inMemorySessionId
  const storage = safeGetStorage()
  const existing = storage?.getItem(SESSION_KEY)?.trim() || ''
  if (existing) {
    inMemorySessionId = existing
    return inMemorySessionId
  }
  inMemorySessionId = generateId()
  storage?.setItem(SESSION_KEY, inMemorySessionId)
  return inMemorySessionId
}
